import { ExpandIcon } from 'lucide-react';
import { useTranslation } from 'react-i18next';

import { previewIconByType } from '@/redux/dialogs/helper';
import { urlPattern } from '@/util/validation/patterns';
import { urlSchema } from '@/util/validation/schema-builders';

import styles from './Preview.module.scss';

const Preview = ({ action }) => {
  const { t } = useTranslation();
  const { url, name, type } = action;

  const renderImage = () => {
    switch (type) {
      case 'video':
        return <video src={url} muted />;
      case 'image':
        return <img alt={name} src={url} referrerPolicy="no-referrer" />;
      default:
        return previewIconByType(type);
    }
  };

  // Cases like https://www.google.com pass
  if (urlPattern.test(url)) {
    return (
      <div className={styles.wrapper}>
        {renderImage()}
        <a
          href={url}
          target="_blank"
          onClick={(e) => e.stopPropagation()}
          onKeyUp={(e) => e.stopPropagation()}
          className={styles.wrapper__label}
          rel="noopener"
        >
          <ExpandIcon size={14} className="text-muted-foreground" />
          <span className="text-sm leading-5 font-semibold text-primary">
            {t('common.preview')}
          </span>
        </a>
      </div>
    );
  }

  // Cases like {{$url}} or https://example.com/{{\$dynamicPath}}/resource pass
  if (urlSchema.isValidSync(url)) {
    return (
      <div className={styles.wrapper}>
        <span className="text-sm leading-5 text-primary">{url}</span>
      </div>
    );
  }

  return (
    <div className={styles.empty}>
      <span className="text-sm leading-5 font-semibold text-muted-foreground">
        {t('common.empty')}
      </span>
    </div>
  );
};

export default Preview;
